import { ICollectionGeneric } from '@belong/contentful/factories';
import { useCMSPage } from '@belong/contentful/hooks';
import { ILinkItem } from '@belong/types';
import { Column, Columns, Heading, LinkList, Section, Skeleton, Stack } from '@belong/ui-components';

interface IAccountRecoveryPage {
  actions: ICollectionGeneric<ILinkItem>;
}

export const AccountRecoveryPage = () => {
  const { data, loading, error } = useCMSPage<IAccountRecoveryPage>();

  if (loading || error || !data?.content) {
    return <Skeleton />;
  }

  const { actions } = data.content;

  return (
    <Section hasPaddingTop hasPaddingBottom>
      <Columns alignX="center">
        <Column width={{ lg: '2/3', xl: '1/2' }}>
          <Stack space={{ xs: 'large', md: 'xlarge' }}>
            <Heading alignment="center" as="h1">
              {actions.title}
            </Heading>
            <LinkList items={actions.collection} />
          </Stack>
        </Column>
      </Columns>
    </Section>
  );
};
